__turbopack_context__.v({
  "controls": "search-module-scss-module__Qi6LcG__controls",
  "reset": "search-module-scss-module__Qi6LcG__reset",
  "search": "search-module-scss-module__Qi6LcG__search",
  "wrapper": "search-module-scss-module__Qi6LcG__wrapper",
});
